import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Children, ReactNode, RefObject, useEffect, useRef, useState } from "react";
export type FilterCollapseType = {
  children: ReactNode;
  active?: boolean;
  className?: string;
  containerClassName?: string;
};
export const useFilterCollapse = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const [showAll, setShowAll] = useState(false);
  const containerReference = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [allElementHeight, setAllElementHeight] = useState();
  const numberOfChildren = Children.count(children);
  let t1;
  let t2;
  if ($[0] !== numberOfChildren) {
    t1 = () => {
      const firstChild = containerReference.current?.firstElementChild as HTMLElement;
      if (firstChild) {
        const firstChildHeight = firstChild.offsetHeight;
        setContainerHeight(firstChildHeight * 5);
        setAllElementHeight(firstChildHeight * numberOfChildren);
      }
    };
    t2 = [numberOfChildren];
    $[0] = numberOfChildren;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = showAll ? "\u0628\u0633\u062A\u0646" : "\u0645\u0648\u0627\u0631\u062F \u0628\u06CC\u0634\u062A\u0631";
  const t4 = showAll ? "arrow_drop_up" : "arrow_drop_down";
  let t5;
  if ($[3] !== t4) {
    t5 = <MaterialIcon className="text-sm" name={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setShowAll(_temp);
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t5) {
    t7 = {
      children: t3,
      EndIcon: t5,
      color: "secondary" as const,
      type: "button" as const,
      onClick: t6,
      variant: "text" as const
    };
    $[6] = t3;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== allElementHeight || $[10] !== children || $[11] !== containerHeight || $[12] !== showAll || $[13] !== t7) {
    t8 = {
      children,
      containerHeight,
      allElementHeight,
      showAll,
      containerReference,
      buttonProps: t7
    };
    $[9] = allElementHeight;
    $[10] = children;
    $[11] = containerHeight;
    $[12] = showAll;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp(previous) {
  return !previous;
}